import { SelectedTicketsProvider } from "../contexts/tickets/selectedTickets.context";
import { Outlet } from "react-router-dom";

const RootLayout = () => {
  return (
    <SelectedTicketsProvider>
      <Outlet />
    </SelectedTicketsProvider>
  );
};

export default RootLayout;
